module.exports = __webpack_public_path__ + "img/error1.8aab2778.jpg";